import { ObservableActionCreator } from 'common/utils/actions/ObservableActionCreator'
import { ISearchAction, ISearchPayload } from 'App/types/search'

export const searchAction = new ObservableActionCreator<
  ISearchPayload,
  ISearchAction
>('App/search')
